<template>
  <v-app style="background:#FFFFFF!important">
    <!-- TEMPORAL -->
    <template v-if="!accesoAutorizado">
      <Alerta />
      <v-bottom-sheet v-model="cookies">
        <v-sheet class="text-center" persistent>
          <p class="pt-5 pb-2 subtitle-1">{{$t('Alerta.AlIngresar')}} <a :href="`https://trartist.com${$t('Alias.PoliticaDePrivacidad')}`"><b>{{$t('Menu.PoliticaDePrivacidad')}}</b></a> y <a :href="`https://trartist.com${$t('Alias.TyC')}`"><b>{{$t('Menu.TyC')}}</b></a>.</p>
          <v-btn class="mb-5 mx-2" color="black white--text" text small :to="$t('Alias.PoliticaDePrivacidad')">{{$t('Formularios.VerMas')}}</v-btn>
          <v-btn class="mb-5 mx-2" @click="cookies = false" color="black white--text" multi-line>{{$t('Formularios.Acepto')}}</v-btn>
        </v-sheet>
      </v-bottom-sheet>
      <v-container fill-height style="background: rgb(248, 241, 0)!important">
        <vueHeadful v-if="getIdioma === 'es'"
          title="TrArtist - Artistas y Diseñadores"
          description="Galería de Artistas y Diseñadores Internacional"
          :url="'https://trartist.com' + $route.fullPath"
          :lang="getIdioma"
        />
        <vueHeadful v-else
          title="TrArtist - Designers and Artists"
          description="International Artists and Designers Gallery"
          :url="'https://trartist.com' + $route.fullPath"
          :lang="getIdioma"
        />
        <v-row justify="space-around">
            <v-col cols="8" xs="8" md="4" align="center">
                <LogoAnimado :porcentaje="porcentaje"/>
            </v-col>
            <v-col cols="12" />
            <v-col cols="8" xs="8" md="4" align="center">
              <v-text-field @keyup.enter="validar()" solo v-model="codigo" />
              <v-btn @click="validar()" color="primary" x-large>Ingresar</v-btn>
            </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-else>
        <Navegacion/>
      <v-content>
        <Alerta />
        <Newsletter/>
        <router-view />
      </v-content>
      <v-footer style="padding:0!important;">
        <Footer />
      </v-footer>
    </template>
    <!-- NORMAL -->
    <!-- <template>
        <Navegacion/>
      <v-content>
        <Alerta />
        <v-bottom-sheet v-model="cookies">
          <v-sheet class="text-center">
            <p class="pt-5 pb-2 subtitle-1">{{$t('Alerta.AlIngresar')}} <a :href="`http://localhost:8081${$t('Alias.PoliticaDePrivacidad')}`"><b>{{$t('Menu.PoliticaDePrivacidad')}}</b></a> y <a :href="`http://localhost:8081${$t('Alias.TyC')}`"><b>{{$t('Menu.TyC')}}</b></a>.</p>
            <v-btn class="mb-5 mx-2" @click="cookies = false" color="black white--text" multi-line>{{$t('Alerta.Entendido')}}</v-btn>
            <v-btn class="mb-5 mx-2" @click="cookies = false" color="black white--text" multi-line :to="$t('Alias.PoliticaDePrivacidad')">{{$t('Alerta.VerMas')}}</v-btn>
          </v-sheet>
        </v-bottom-sheet>
        <Newsletter/>
        <router-view />
      </v-content>
      <v-footer style="padding:0!important;">
        <Footer />
      </v-footer>
    </template> -->
    <!-- <template v-else>
      <v-container fill-height style="background-color:#F8F100">
        <v-row justify="space-around">
            <v-col cols="6" xs="6" md="4" lg="2" align="center">
                <LogoAnimado/>
            </v-col>
        </v-row>
    </v-container>
    </template> -->
  </v-app>
</template>
<script>
import Navegacion from '@/components/Navegacion.vue'
import Footer from '@/components/Footer.vue'
import LogoAnimado from '@/components/LogoAnimado.vue'
import Alerta from '@/components/Alerta.vue'
import Newsletter from '@/components/Newsletter.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import './assets/styles/main.css'
export default {
  name: 'App',
  data () {
    return {
      accesoAutorizado: false,
      porcentaje: 0,
      codigo: '',
      pwa: null,
      cookies: true
    }
  },
  components: {
    Navegacion,
    Footer,
    LogoAnimado,
    Alerta,
    Newsletter
  },
  computed: {
    ...mapGetters(['getCargado', 'getRol', 'getPorcentajeCarga', 'getIdioma'])
  },
  methods: {
    ...mapMutations(['setUsuario', 'setLogeado', 'setComision', 'setDolar', 'setCargado', 'setNewsletter', 'setPwa', 'setMostrado', 'setAlerta', 'setTextoAlerta', 'setCarritoHabilitado']),
    ...mapActions(['verificarCarrito']),
    validar () {
      if (this.codigo === 'yoquiero333') {
        this.accesoAutorizado = true
        localStorage.accesoAutorizado = this.accesoAutorizado
        //  console.log(this.accesoAutorizado)
      } else {
        this.setAlerta()
        this.setTextoAlerta('Alerta.CodigoIncorrecto')
      }
    }
  },
  beforeMount () {
    firebase.auth().onAuthStateChanged(usuario => {
      if (usuario) {
        firebase.firestore().collection('usuarios').doc(usuario.uid).onSnapshot(snapshot => {
          if (snapshot.exists) {
            this.setUsuario(snapshot.data())
            this.setLogeado(true)
            this.setCargado(true)
          } else {
            this.setLogeado(false)
            this.setCargado(true)
          }
        })
      } else {
        this.setLogeado(false)
        this.setCargado(true)
        setTimeout(() => this.setNewsletter(true), 1200000)
      }
    })
    firebase.firestore().collection('utilidades').doc('seguridad').get().then(info => {
      this.setCarritoHabilitado(info.data().carrito)
    })
    firebase.firestore().collection('utilidades').doc('monetario').get().then(info => {
      this.setComision(info.data().comision)
      this.setDolar(info.data().dolar)
    })
    var productos = localStorage.getItem('carrito')
    if (productos) {
      this.verificarCarrito(JSON.parse(productos))
    }
  },
  mounted () {
    if (localStorage.accesoAutorizado) {
      this.accesoAutorizado = localStorage.accesoAutorizado
      // setTimeout(() => {
      //   localStorage.removeItem('accesoAutorizado')
      // }, 60000)
    }
    setInterval(() => this.porcentaje = this.porcentaje + 10, 200) // eslint-disable-line
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.setPwa(e)
    })
    if (window.matchMedia('(display-mode: standalone)').matches) {
      this.setMostrado(true)
    }
    window.addEventListener('appinstalled', (evt) => {
      this.setMostrado(true)
    })
  }
}
</script>

<style>
.grecaptcha-badge {
  display: none!important;
}
.textoMagazine p {
  font-size: 20px;
  line-height: 40px;
}
.textoMagazine a {
  color: #4180FF!important;
}
.textoMagazine img {
  max-width: 100%;
  min-width: 60%;
  /* width: 100%; */
}
.ql-video {
  width: 100vw;
  height: 32.3vw;
  max-width: 100%;
}
.ql-editor{
  min-height:200px;
  font-size:16px
  }
.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{
  stroke-width:1px!important
}
.quillWrapper .ql-snow.ql-toolbar{
  padding-top:8px;padding-bottom:4px
}
.quillWrapper .ql-snow.ql-toolbar .ql-formats{
  margin-bottom:10px
}
.ql-snow .ql-toolbar button svg,.quillWrapper .ql-snow.ql-toolbar button svg{
  width:22px;height:22px
}
.quillWrapper .ql-editor ul[data-checked=false]>li::before,.quillWrapper .ql-editor ul[data-checked=true]>li::before{
  font-size:1.35em;
  vertical-align:baseline;
  bottom:-.065em;
  font-weight:900;
  color:#222
}
.quillWrapper .ql-snow .ql-stroke{
  stroke:rgba(63,63,63,.95);stroke-linecap:square;stroke-linejoin:initial;stroke-width:1.7px
}
.quillWrapper .ql-picker-label{
  font-size:15px
}
.quillWrapper .ql-snow .ql-active .ql-stroke{
  stroke-width:2.25px
}
.quillWrapper .ql-toolbar.ql-snow .ql-formats{
  vertical-align:top
}
.ql-picker:not(.ql-background){
  position:relative;top:2px
}
.ql-picker.ql-color-picker svg{
  width:22px!important;
  height:22px!important
}
.quillWrapper .imageResizeActive img{
  display:block;cursor:pointer
}
.quillWrapper .imageResizeActive~div svg{
  cursor:pointer
}
.quillWrapper {
  word-break: break-word;
}
.ql-align-center {
  text-align: center;
}
.v-textarea textarea {
  line-height: 30px!important;
}
.v-text-field input {
  line-height: 22px!important;
}
.v-textarea textarea {
  line-height: 30px;
}
.v-application, .vietnam, p, h1, h2, h3, h4, h5, h6 {
  font-family: 'Be Vietnam', sans-serif!important;
  color: black;
  text-rendering: auto;
  text-shadow: 0 !important;
}
.botonRaro {
  border-radius: 0!important;
  font-weight: 600!important;
}
.descripcion {
    font-size: 24px;
}
a {
  text-decoration: none!important;
  color: initial!important;
}
.margen {
  margin: 5% !important;
}
.margenFormulario {
  margin: 0 20% !important;
}
.padding {
  padding: 5% !important;
}
.container {
  max-width: -webkit-fill-available!important;
}
.v-label, input {
  font-weight: 300!important;
}
.v-text-field, .v-btn {
  border-radius: 0!important;
}
#imagen .v-image__image{
  opacity: 0.6!important;
}
#imagen {
  cursor: pointer;
}
.botonRaro {
  border-radius: 0!important;
  font-weight: 600!important;
}
.theme--light.v-label, .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: black!important;
  font-size:18px;
  font-family: 'Be Vietnam', sans-serif!important;
  font-weight: 400!important;
}
.v-input .v-label {
  height: 22px!important;
}
.v-data-table th, .v-data-table td {
  font-size:16px!important;
}
.textoMagazine h1, .ql-editor h1 {
  font-size: 40px!important;
}
.textoMagazine h2, .ql-editor h2 {
  font-size: 34px!important;
}
.textoMagazine h3, .ql-editor h3 {
  font-size: 30px!important;
}
.textoMagazine h4, .ql-editor h4 {
  font-size: 26px!important;
}
.textoMagazine h5, .ql-editor h5 {
  font-size: 22px!important;
}
.textoMagazine h6, .ql-editor h6 {
  font-size: 18px!important;
}
/* h1, h2, h3, h4, h5, h6, p, span {
  word-break:break-word!important;
} */
</style>
